@if (count() > 0) {
    <div
        class="fixed right-6 z-[79] flex flex-col items-end"
        [class]="stackAboveCallBar() ? 'bottom-[200px]' : 'bottom-6'">
        @if (expanded()) {
            <!-- Expanded panel -->
            <div
                class="flex w-[330px] animate-rise-fade flex-col overflow-hidden rounded-2xl border border-zinc-200/70 bg-twComponentBackground/95 shadow-popMenu backdrop-blur-md">
                <header class="flex items-center gap-2 border-b border-zinc-100 py-3 pl-4 pr-2.5">
                    <span class="relative flex size-2 shrink-0">
                        <span
                            class="absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
                        <span
                            class="relative inline-flex size-2 rounded-full bg-emerald-500"></span>
                    </span>
                    <h3 class="text-[13px] font-semibold tracking-[-0.005em] text-twTextPrimary">
                        {{ 'voice.call.queue.title' | translate }}
                    </h3>
                    <span class="tw-pill-success">{{ count() }}</span>
                    <div class="ml-auto flex items-center gap-0.5">
                        <button
                            class="flex size-7 items-center justify-center rounded-lg text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-twTextPrimary"
                            type="button"
                            [attr.aria-label]="
                                (soundOn()
                                    ? 'voice.call.queue.soundOff'
                                    : 'voice.call.queue.soundOn'
                                ) | translate
                            "
                            [title]="
                                (soundOn()
                                    ? 'voice.call.queue.soundOff'
                                    : 'voice.call.queue.soundOn'
                                ) | translate
                            "
                            (click)="toggleSound()">
                            <lucide-icon
                                [img]="soundOn() ? BellIcon : BellOffIcon"
                                [size]="15"
                                [strokeWidth]="1.75" />
                        </button>
                        <button
                            class="flex size-7 items-center justify-center rounded-lg text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-twTextPrimary"
                            type="button"
                            [attr.aria-label]="'voice.call.queue.collapse' | translate"
                            [title]="'voice.call.queue.collapse' | translate"
                            (click)="toggleExpanded()">
                            <lucide-icon [img]="ChevronDownIcon" [size]="16" [strokeWidth]="1.75" />
                        </button>
                    </div>
                </header>

                <div class="flex max-h-[320px] flex-col divide-y divide-zinc-100 overflow-y-auto">
                    @for (entry of waiting(); track entry.event.conversation_id) {
                        <div
                            class="flex items-center gap-3 px-4 py-3"
                            [class]="entry.forMe ? 'bg-emerald-50/70' : ''">
                            <tw-contact-avatar
                                class="shrink-0"
                                size="md"
                                [id]="entry.event.conversation_id"
                                [imgUrl]="entry.imgUrl"
                                [name]="entry.name" />
                            <div class="flex min-w-0 flex-1 flex-col gap-0.5">
                                <span class="flex min-w-0 items-center gap-1.5">
                                    <span
                                        class="truncate text-[13px] font-medium tracking-[-0.005em] text-twTextPrimary">
                                        {{
                                            entry.name ||
                                                ('voice.call.queue.unknownCaller' | translate)
                                        }}
                                    </span>
                                    @if (entry.forMe) {
                                        <span class="tw-pill-success shrink-0 animate-pulse">
                                            {{ 'voice.call.queue.forYou' | translate }}
                                        </span>
                                    } @else if (entry.targetName) {
                                        <span
                                            class="inline-flex shrink-0 items-center rounded-md bg-zinc-50 px-1.5 py-0.5 text-[10.5px] font-medium text-zinc-500 ring-1 ring-inset ring-zinc-200/70">
                                            {{
                                                'voice.call.queue.forUser'
                                                    | translate: { name: entry.targetName }
                                            }}
                                        </span>
                                    }
                                </span>
                                <span class="flex items-center gap-1.5">
                                    <span
                                        class="size-1.5 shrink-0 rounded-full"
                                        [class]="slaDotClass(waitSecOf(entry))"></span>
                                    <span
                                        class="font-mono text-[12px] tabular-nums"
                                        [class]="slaClass(waitSecOf(entry))">
                                        {{ waitLabel(waitSecOf(entry)) }}
                                    </span>
                                    @if (entry.isWhatsapp) {
                                        <app-contact-channel-icons
                                            class="size-3.5 shrink-0"
                                            [channel]="VOICE_CHANNEL"
                                            [title]="'voice.call.queue.whatsappCall' | translate"
                                            [voiceType]="WA_TYPE" />
                                    }
                                    @if (entry.origin) {
                                        <span class="truncate font-mono text-[11.5px] text-zinc-400"
                                            >· {{ entry.origin }}</span
                                        >
                                    }
                                </span>
                            </div>
                            <button
                                class="inline-flex h-7 shrink-0 items-center gap-1.5 rounded-full bg-emerald-600 px-3 text-[12px] font-semibold text-white transition-colors hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
                                type="button"
                                [disabled]="!isPickupReady(entry) || onCall() || isPickingUp(entry)"
                                [title]="
                                    onCall() ? ('voice.call.queue.onCallHint' | translate) : ''
                                "
                                (click)="pickup(entry)">
                                @if (isPickingUp(entry) || !isPickupReady(entry)) {
                                    <lucide-icon
                                        class="animate-spin"
                                        [img]="LoaderIcon"
                                        [size]="13"
                                        [strokeWidth]="2" />
                                } @else {
                                    <lucide-icon
                                        [img]="PhoneCallIcon"
                                        [size]="13"
                                        [strokeWidth]="2" />
                                }
                                {{ 'voice.call.preview.pickup' | translate }}
                            </button>
                            <button
                                class="flex size-6 shrink-0 items-center justify-center rounded-md text-zinc-300 transition-colors hover:bg-zinc-100 hover:text-zinc-500"
                                type="button"
                                [attr.aria-label]="'voice.call.queue.dismiss' | translate"
                                [title]="'voice.call.queue.dismiss' | translate"
                                (click)="dismiss(entry)">
                                <lucide-icon [img]="XIcon" [size]="14" [strokeWidth]="1.75" />
                            </button>
                        </div>
                    }
                </div>

                @if (onCall()) {
                    <footer class="border-t border-zinc-100 bg-zinc-50/70 px-4 py-2">
                        <span class="text-[11.5px] text-zinc-500">{{
                            'voice.call.queue.onCallHint' | translate
                        }}</span>
                    </footer>
                }
            </div>
        } @else {
            <!-- Collapsed pill -->
            <button
                class="flex h-11 animate-rise-fade items-center gap-2.5 rounded-full border border-emerald-200/70 bg-twComponentBackground/95 pl-1.5 pr-4 shadow-popMenu backdrop-blur-md transition-transform hover:-translate-y-0.5"
                type="button"
                (click)="toggleExpanded()">
                <span
                    class="relative flex size-8 items-center justify-center rounded-full bg-emerald-50 ring-1 ring-inset ring-emerald-200/70">
                    <lucide-icon
                        class="queue-ring-icon text-emerald-600"
                        [img]="PhoneIncomingIcon"
                        [size]="16"
                        [strokeWidth]="1.75" />
                    <span class="absolute -right-0.5 -top-0.5 flex size-2.5">
                        <span
                            class="absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
                        <span
                            class="relative inline-flex size-2.5 rounded-full bg-emerald-500"></span>
                    </span>
                </span>
                <span class="text-[13px] font-semibold tracking-[-0.005em] text-twTextPrimary">
                    @if (hasCallForMe()) {
                        {{ 'voice.call.queue.incomingForYou' | translate }}
                    } @else {
                        {{
                            (count() === 1
                                ? 'voice.call.queue.waitingOne'
                                : 'voice.call.queue.waitingMany'
                            ) | translate: { count: count() }
                        }}
                    }
                </span>
            </button>
        }
    </div>
}
